import React from 'react'

import {
    ContentSlider,
    HeroBanner,
    HeroBannerPro,
    GenericHtmlContent,
    SideCard,
    TextGroup,
    PaddingBlock,
    PromoSlider,
    PromoSliderImage,
    PromoSliderVideo,
    AccordionBlock,
    Gallery,
    Moodboard,
    Steps,
    Sorting,
    ShopTheLook,
    Stories,
    PLPWhiteBanner,
    ProductMoodboard,
    KeyFeatures,
    EditorialVideo,
    ContentCards,
    PLPBannerPromo,
    Disclaimer,
    Pricing,
    QuickLinks,
    PaperlessBanner,
    NewsletterBanner,
    FaqsBanner,
    PDPBannerPromo,
    // eslint-disable-next-line @typescript-eslint/ban-ts-comment
    // @ts-ignore
} from '.'

interface ContentSliderResGroup {
    contentSliderGroup: Array<{
        media?: {
            url: string
            title: string
        }
        textblock?: {
            label: string
            label_paragraph: string
            title: string
            body_copy: string
        }
    }>
}

interface SliderGroupResProps {
    sliderGroup: Array<{
        text_block: {
            title: string
            body_copy: string
            cta: {
                title: string
                href: string
            }
            is_external_url: boolean
        }
        media: {
            url: string
            alt: string
        }
    }>
}

interface StepsGroupProps {
    stepsGroup: Array<{
        title: string
        body_copy: string
    }>
}

interface SortingGroupResProps {
    sortingGroup: Array<{
        title: string
        body_copy: string
        media: {
            url: string
            alt: string
        }
        features: Array<{
            feature: string
        }>
        cta: {
            title: string
            href: string
        }
    }>
}

interface ProductMoodboardProductResProps {
    id?: string
    name?: string
    image?: {
        alt?: string
        link?: string
        title?: string
    }
    currency?: string
    price?: number
}

interface ProductMoodboardGroupResProps {
    label?: string
    products?: {
        data?: ProductMoodboardProductResProps[]
    }
}

interface PricingProductResProps {
    id?: string
    name?: string
    image?: {
        alt?: string
        link?: string
        title?: string
    }
    currency?: string
    timing?: string
    addendum?: string
    shortDescription?: string
    c_pricesFirst?: number
    c_pricesRecurring?: number
    c_costPerCoffee?: string
    c_coffeePerDay?: string
    c_subDuration?: string
    c_subDiscountPercentage?: string
}

interface PricingGroupResProps {
    isBestSeller?: boolean
    timing?: string
    products?: {
        data?: PricingProductResProps[]
    }
}

interface MoodboardResProps {
    text_block: {
        title: string
        body_copy: string
    }
    cta: {
        title: string
        href: string
    }
    image: {
        url: string
        alt: string
    }
}

interface AccordionGroupResProps {
    details: string
    summary: string
}

interface StandardAccordionResProps {
    accordion_title: string
    accordion_title_font_size: string
    paragraph: string
    secondary_title: string
}

interface ValueAccordionResProps {
    accordion_title: string
    secondary_title: string
    values: {has_check: boolean; value: string; value_name: string}[]
}

interface MediaProps {
    url: string
    content_type: string
    title: string
}

interface GalleryMediaLayoutProps {
    _content_type_uid: string
    media_1?: {
        is_video: boolean
        video: object[]
        image: SideCardImageGroupProps
    }
    media_2?: {
        is_video: boolean
        video: object[]
        image: SideCardImageGroupProps
    }
    media_3?: {
        is_video: boolean
        video: object[]
        image: SideCardImageGroupProps
    }
}

interface SideCardImageGroupProps {
    desktop: {
        rendition: string
        dam_image: string
    }
    mobile: {
        rendition: string
        dam_image: string
    }
    tablet_1024: {
        rendition: string
        dam_image: string
    }
    tablet_768: {
        rendition: string
        dam_image: string
    }
}
interface ButtonConfigProps {
    categorysfcc: {
        type: string
    }
    cta: {
        title: string
        href: string
    }
    psp_url: []
}
interface SideCardApplicationGroupProps {
    app_buttons: []
    title: string
}

interface StoriesProps {
    title?: string
    body_copy?: string
    heading?: string
    button?: ButtonConfigProps
    image?: SideCardImageGroupProps
    media?: {
        is_video: boolean
        video: object[]
        image: SideCardImageGroupProps
    }
}

interface EditorialComponentsFactoryProps {
    componentType: string
    content_slider_group?: ContentSliderResGroup[]
    cta?: {title: string; href: string}
    cta2?: {title: string; href: string}
    textblock?: {
        label: string
        title: string
        bodycopy: string
        desktopalignment: string
        tabletmobilealignment: string
    }
    media?: MediaProps
    maskgroup?: {
        maskheaderactive?: boolean
        opacity: string
    }
    backgroundcolor?: string
    accordioncolor?: string
    contentheight?: string
    slider_group?: SliderGroupResProps[]
    steps_group?: StepsGroupProps[]
    sorting_group?: SortingGroupResProps[]
    sorting_slider_group?: SortingGroupResProps[]
    product_moodboard_group?: ProductMoodboardGroupResProps[]
    pricing_group?: PricingGroupResProps[]
    heading?: string
    title?: string
    header_copy?: string
    body_copy?: string
    label?: string
    accordion_group?: AccordionGroupResProps[]
    standard_accordion?: StandardAccordionResProps[]
    component_title?: string
    value_accordion?: ValueAccordionResProps[]
    has_paddings?: boolean
    has_slider?: boolean
    categorysfcc?: object
    moodboard_group?: MoodboardResProps[]
    size?: string
    color?: string
    text_group: {
        bodycopystandard: string
        cta_title: string
        label: string
        title: string
    }
    text_group_pdp: {
        bodycopy: string
        expand_cta_title: string
        close_cta_title: string
    }
    image?: SideCardImageGroupProps[]
    images?: SideCardImageGroupProps[]
    image_standard?: SideCardImageGroupProps[]
    image_full?: SideCardImageGroupProps[]
    image_pdp?: SideCardImageGroupProps[]
    image_position?: string
    is_video?: boolean
    video?: object[]
    videos?: object[]
    type?: string
    background_color?: string
    application_group?: SideCardApplicationGroupProps
    button?: ButtonConfigProps
    buttons?: ButtonConfigProps[]
    feature_cards?: {
        title: string
        body_copy: string
        image: {
            url: string
        }
        iscategorylink: boolean
        categorysfcc: object
        psp_url: string
        categorylabel: string
    }[]
    stories_group?: StoriesProps[]
    screen_start?: StoriesProps
    screen_end?: StoriesProps
    has_close_button?: boolean
    autoplay_delay?: number
    media_layouts?: GalleryMediaLayoutProps[]
    links_title?: string
    quick_link?: {
        button: {
            categorysfcc: object
            psp_url: string
        }
        icon: {
            url: string
        }
    }[]
    uid?: string
    subtitle?: string
    campaign_tag?: string
    banner_title?: string
    banner_subtitle?: string
    form_title?: string
    form_subtitle?: string
    is_marketing_consent_mandatory_?: boolean
    thank_you_title?: string
    thank_you_subtitle?: string
    thank_you_disclaimer?: string
    thank_you_date_label?: string
    titleAs?: string
    wrapper?: string
    isFirstElement?: boolean
    // add more as it grows
}

type ComponentFactory = () => JSX.Element
type ComponentMap = Record<string, ComponentFactory>

const EditorialComponentsFactory: React.FC<EditorialComponentsFactoryProps> = ({
    componentType,
    ...props
}) => {
    //TODO move all this constants inside the block scope that they are used below
    const media = {
        url: props?.media?.url,
        contentType: props?.media?.content_type,
        title: props?.media?.title,
    }
    const textBlock = {
        label: props?.textblock?.label,
        title: props?.textblock?.title,
        bodyCopy: props?.textblock?.bodycopy,
        desktopAlignment: props?.textblock?.desktopalignment,
        tabletMobileAlignment: props?.textblock?.tabletmobilealignment,
    }

    const componentMap: ComponentMap = {
        herobanner: () => {
            return (
                <HeroBanner
                    {...props}
                    media={media}
                    isMaskHeaderActive={!!props?.maskgroup?.maskheaderactive}
                    textBlock={textBlock}
                    variant={props?.backgroundcolor}
                    height={props?.contentheight}
                    buttonText={props?.button}
                />
            )
        },
        hero_banner: () => {
            return (
                <HeroBannerPro
                    {...props}
                    media={media}
                    isMaskHeaderActive={!!props?.maskgroup?.maskheaderactive}
                    textBlock={textBlock}
                    variant={props?.backgroundcolor}
                    height={props?.contentheight}
                    buttonText={props?.button}
                />
            )
        },
        coffee_lounge_component: () => {
            return (
                <HeroBanner
                    {...props}
                    media={media}
                    isMaskHeaderActive={!!props?.maskgroup?.maskheaderactive}
                    textBlock={textBlock}
                    variant={props?.backgroundcolor}
                    height="mid"
                    buttonText={props?.button}
                />
            )
        },
        generic_html_content: () => {
            return <GenericHtmlContent bodycopy={props?.body_copy} />
        },
        pricing: () => {
            return (
                <Pricing
                    title={props?.title}
                    heading={props?.heading}
                    bodycopy={props?.body_copy}
                    pricingGroup={props?.pricing_group}
                />
            )
        },
        promo_slider: () => {
            return <PromoSlider heading={props?.heading} sliderGroup={props?.slider_group} />
        },
        promo_slider_image: () => {
            return (
                <PromoSliderImage
                    heading={props?.heading}
                    sliderGroup={props?.slider_group}
                    uid={props?.uid}
                />
            )
        },
        promo_slider_video: () => {
            return <PromoSliderVideo sliderGroup={props?.slider_group} />
        },
        accordions: () => {
            return (
                <AccordionBlock
                    variant={props?.backgroundcolor}
                    accordionVariant={props?.accordioncolor}
                    isEditorial={true}
                    items={props?.accordion_group}
                />
            )
        },
        specifications: () => {
            const standardAccordion = props?.standard_accordion ?? []
            const valueAccordion = props?.value_accordion ?? []
            const accordionItems = [...standardAccordion, ...valueAccordion]

            return (
                <AccordionBlock
                    isEditorial={true}
                    title={props?.component_title}
                    items={accordionItems}
                />
            )
        },
        category_moodboard: () => {
            return (
                <Moodboard
                    hasPaddings={props?.has_paddings}
                    moodboardGroup={props?.moodboard_group}
                />
            )
        },
        plpwhitebanner: () => {
            return (
                <PLPWhiteBanner
                    heading={props?.heading}
                    bodycopy={props?.body_copy}
                    isVideo={props?.is_video}
                    image={props?.image}
                    video={props?.video && props?.video.length ? props?.video[0] : null}
                    variant={props?.wrapper}
                    isFirstElement={props?.isFirstElement ?? false}
                    titleAs={props?.titleAs}
                />
            )
        },
        key_features: () => {
            return (
                <KeyFeatures
                    title={props.header_copy}
                    description={props.body_copy}
                    cards={props.feature_cards}
                />
            )
        },
        content_cards: () => {
            return <ContentCards contentData={props} />
        },
        sorting: () => {
            return (
                <Sorting
                    hasSlider={false}
                    title={props?.title}
                    variant={props?.backgroundcolor}
                    heading={props?.heading}
                    bodycopy={props?.body_copy}
                    sortingGroup={props?.sorting_group}
                    buttons={props?.buttons}
                />
            )
        },
        sorting_slider: () => {
            return (
                <Sorting
                    hasSlider={props?.has_slider}
                    title={props?.title}
                    variant={props?.backgroundcolor}
                    heading={props?.heading}
                    bodycopy={props?.body_copy}
                    sortingGroup={props?.sorting_slider_group}
                />
            )
        },
        padding_block: () => {
            return <PaddingBlock size={props.size} color={props.color} />
        },
        text_group: () => {
            return (
                <TextGroup
                    {...props}
                    title={props.header_copy}
                    description={props.body_copy}
                    color={props.color}
                />
            )
        },
        steps: () => {
            return (
                <Steps
                    heading={props?.heading}
                    image={props?.image}
                    stepsGroup={props?.steps_group}
                    button={props?.button}
                />
            )
        },
        gallery: () => {
            return (
                <Gallery
                    hasPaddings={props?.has_paddings}
                    variant={props?.backgroundcolor}
                    heading={props?.heading}
                    bodycopy={props?.body_copy}
                    mediaLayouts={props?.media_layouts?.map((ml) => {
                        return {
                            type: ml._content_type_uid ?? '',
                            media1: ml.media_1 ?? null,
                            media2: ml.media_2 ?? null,
                            media3: ml.media_3 ?? null,
                        }
                    })}
                />
            )
        },
        shop_the_look: () => {
            return (
                <ShopTheLook
                    hasPaddings={props?.has_paddings}
                    isVideo={props?.is_video}
                    video={props?.video && props?.video.length ? props?.video[0] : null}
                    image={props?.image}
                    textBlock={textBlock}
                    categorySfcc={props?.categorysfcc}
                />
            )
        },
        content_slider: () => {
            return (
                <ContentSlider
                    title={props?.title}
                    hasPaddings={props?.has_paddings}
                    variant={props?.backgroundcolor}
                    contentSliderGroup={props?.content_slider_group}
                />
            )
        },
        stories: () => {
            return (
                <Stories
                    title={props?.title}
                    screenStart={props?.screen_start}
                    storiesGroup={props?.stories_group}
                    screenEnd={props?.screen_end}
                    hasCloseButton={props?.has_close_button}
                    autoplayDelay={props?.autoplay_delay}
                    maskgroup={props?.maskgroup}
                />
            )
        },
        product_moodboard: () => {
            return <ProductMoodboard productMoodboardGroup={props?.product_moodboard_group} />
        },
        sidecard: () => {
            const textGroup = {
                bodyCopy: props?.text_group?.bodycopystandard,
                label: props?.text_group?.label,
                title: props?.text_group?.title,
            }
            const textGroupPdp = {
                bodyCopy: props?.text_group_pdp?.bodycopy,
                expandCtaTitle: props?.text_group_pdp?.expand_cta_title,
                closeCtaTitle: props?.text_group_pdp?.close_cta_title,
            }
            const imageGroup = {
                image_standard: props?.image_standard,
                image_full: props?.image_full,
                image_pdp: props?.image_pdp,
            }

            return (
                <SideCard
                    videos={props?.videos}
                    textGroup={textGroup}
                    textGroupPdp={textGroupPdp}
                    imageGroup={imageGroup}
                    imageAlt={textGroup?.title}
                    imagePosition={props?.image_position?.toLowerCase()}
                    type={props?.type?.toLowerCase()}
                    backgroundColor={props?.background_color?.toLowerCase()}
                    appDownloadContent={props?.application_group}
                    button={props?.button}
                    hasPaddings={props?.has_paddings}
                    titleAs={props?.titleAs}
                />
            )
        },
        video: () => {
            return <EditorialVideo data={props} />
        },
        plpbannerpromo: () => {
            return (
                <PLPBannerPromo
                    heading={props?.heading}
                    bodycopy={props?.body_copy}
                    image={props?.image}
                    button={props?.button}
                />
            )
        },
        disclaimer: () => {
            return (
                <Disclaimer
                    heading={props?.heading}
                    bodycopy={props?.body_copy}
                    icon={props?.image}
                    links={props?.buttons}
                />
            )
        },
        quick_links: () => {
            return <QuickLinks quickLinksData={props?.quick_link} title={props?.links_title} />
        },
        premium_services_component: () => {
            return (
                <PaperlessBanner
                    title={props?.title}
                    description={props?.subtitle}
                    button={props?.button}
                    image={props?.images}
                />
            )
        },
        newsletter_subscription_form: () => {
            return (
                <NewsletterBanner
                    title={props?.form_title}
                    subtitle={props?.form_subtitle}
                    thankYouLabels={{
                        title: props?.thank_you_title,
                        subtitle: props?.thank_you_subtitle,
                        disclaimer: props?.thank_you_disclaimer,
                        date: props?.thank_you_date_label,
                    }}
                    campaignTag={props?.campaign_tag}
                    pspMarketingConsentMandatory={props?.is_marketing_consent_mandatory_}
                    psp={true}
                />
            )
        },
        faq_page_top_banner: () => {
            return (
                <FaqsBanner
                    heading={props?.banner_title}
                    bodycopy={props?.banner_subtitle}
                    icon={props?.images}
                />
            )
        },
        pdpbannerpromo: () => {
            return <PDPBannerPromo label={props?.label} bodycopy={props?.body_copy} />
        },
        // Add more
    }

    // const [hydrated, setHydrated] = useState<boolean>(false)

    // useEffect(() => {
    //     setHydrated(true)
    // }, [])

    // if (!hydrated) return null

    const Component = componentMap[componentType]

    return (
        <div
            className="editorial-components-root"
            data-ab={`editorial-${componentType}`}
            data-cs-label={`editorial-${componentType}`}
        >
            {Component ? Component() : null}
        </div>
    )
}

{
    /* <React.Suspense fallback={<ComponentSkeleton type={type} />}>
            {Component ? Component() : null}
        </React.Suspense> */
}

// const ComponentSkeleton = ({ type }: { type: string }) => {
//     console.log('does it eeven get here? ')
//     const skeletonMap: Record<string, JSX.Element> = {
//         herobanner: <HeroBannerSkeleton />,
//     }
//     return skeletonMap[type] || <>hello</>
// }

EditorialComponentsFactory.displayName = 'EditorialComponentsFactory'

export default EditorialComponentsFactory
